import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { makeMenuLink } from '../ShoppingCartUtils/Helpers.js';
import { MDBBtn, MDBCollapse } from "mdbreact";
import Overlay from '../Overlay/Overlay.js';

class SideNavigation extends Component {
  constructor() {
    super();
    this.state = {
      collapseID: "",
      sideBarIsOpen: "",
      interim: "",
      catgCollapse: true,
    };
    this.closeMenu = this.closeMenu.bind(this);
    this.onClickDuo = this.onClickDuo.bind(this);
    this.handleCategoryButtonClick = this.handleCategoryButtonClick.bind(this);
    this.catgButtonLink = '';
    this.prevPropsValue = null;
  }

  componentDidMount() {
    if (!this.catgButtonLink) {
      this.catgButtonLink = document.querySelector('.side-menu__category__button__link'); // select side menu category link dropdown
    }
  }

  componentDidUpdate(prevProps) {
    this.prevPropsValue = prevProps;
    if (this.catgButtonLink) {
      if (this.props.toggle !== this.prevPropsValue.toggle) { // If the toggle prop parent state updates then 
        this.catgButtonLink.focus(); // Set focus to the category dropdown link
      }
    }
  }
  /**
   * Method that toggle between the current and previous state of the MDBCollapse dropdown in the sideMenu.
   */
  toggleCollapse(collapseID) {
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    }));
  }
  /**
   *  Method that closes the sidemenu.
   * 
   * @param {event} event 
   */
  closeMenu(event) {
    this.props.closeSideBar(event);
  }
  /**
   * Method that helps category dropdown state changes.
   * 
   * @param {event} event 
   */
  handleCategoryButtonClick() {
    this.setState(prevState => ({
      catgCollapse: prevState.catgCollapse === true ? false : true
    }));
  }
  /**
   * Handles the category dropdown collapse class changes.
   * 
   * @param {string} catgLink - id for the categoryLink dropdown in sideMenu
   * @param {event} event 
   */
  onClickDuo(catgLink, event) {
    this.toggleCollapse(catgLink);
    this.handleCategoryButtonClick(event);
  }
  /**
   * Used for determining which links to select for the current page.
   * @param {object} linkData - data for the link coming from the json file which provides all link detail
   * @param {string} pathName - the pathname of the current page.
   */
  handleSideMenuPageIndication(linkData, pathName) {
    let currentClass;
    if (linkData === pathName) {
      currentClass = 'main-nav__link current';
    } else {
      currentClass = 'main-nav__link';
    }
    return currentClass;
  }

  render() {
    {/*Removed from side-menu__category__button__link on 12/15/2020: aria-controls="sideCatgLink"*/ }
    return (
      <div>
        <div id="sideBar" className={'side-menu__block ' + this.props.toggle}>
          <div className="side-menu__title side-menu-title"> <a href="/" className="side-menu__title__link" tabIndex="0" aria-label="Sidebar Logo"><img className="side-menu__corp__logo side-tab-nav-logo" src="https://cdn.skyelearning.com/static/skye-logos/skye-learning-logo-rgb-shorthand-horizontal-tablet.svg" alt="Skye Learning Logo Tablet" /></a> </div>
          <div className="side-menu__category__button" id="sideCatgBtn">
            <MDBBtn className="side-menu__category__button__link btn btn-primary" data-toggle="collapse" role="button" aria-expanded={!this.state.catgCollapse} tabIndex="0" onClick={(event) => this.onClickDuo("sideCatgLink", event)}> Categories <i className="fas fa-caret-right icon-rotate" aria-hidden="true"></i> </MDBBtn> </div>
          <MDBCollapse className={(this.state.catgCollapse) ? ' ' : ' collapse--show'} id="sideCatgLink" isOpen={this.state.collapseID}>
            <ul className="side-menu__category__list side-catg-menu">
              {(typeof (this.props.categoryList.data) !== 'undefined') ? this.props.categoryList.data.map((item, index) =>

                <React.Fragment key={index}>

                  {(item.category_id && item.course_count > 0) ? <li className="side-menu__category__list__item item1"><a className={'side-menu__category__link ' + this.handleSideMenuPageIndication(makeMenuLink(item.category_id, item.name, '/categories/'), this.props.pathName)} href={makeMenuLink(item.category_id, item.name, '/categories/')}>{ReactHtmlParser(item.name)}</a></li> : ''}

                  {(item.brand_id && item.course_count > 0) ? <li className="side-menu__category__list__item item1"><a className={'side-menu__category__link ' + this.handleSideMenuPageIndication(makeMenuLink(item.brand_id, item.name, '/brands/'), this.props.pathName)} href={makeMenuLink(item.brand_id, item.name, '/brands/')}>{ReactHtmlParser(item.name)}</a></li> : ''}

                </React.Fragment>
              ) : ''}
            </ul>
          </MDBCollapse>
          <div className="dropdown-divider"></div>
          <ul className="side-menu__main__list side-main-menu">
            {(this.props.sidemenuLinks.length > 0) ? this.props.sidemenuLinks.map((menuData, index) =>
              <li className="side-menu__main__list__item" key={index}><a className={'side-menu__main__link ' + this.handleSideMenuPageIndication(menuData.href, this.props.pathName)} href={menuData.href} target={menuData.target} tabIndex="0" rel={menuData.rel ? menuData.rel : ''}>{menuData.link_text}</a></li>
            ) : ''}
            <li className="side-menu__main__list__item"><button className="side-menu__main__link" tabIndex="0" id="closeDrawer" aria-label="Close Mobile Side Menu" onClick={(event) => this.closeMenu(event)}>Close&nbsp;<i className="side-menu__close__icon far fa-times-circle" aria-hidden="true"></i></button></li>
          </ul>
        </div>
        <Overlay
          theState={this.props.overlay}
          theClass="overlay"
          closeSideMenu={this.props.closeSideBar}>
        </Overlay>
      </div>
    );
  }
}

export default SideNavigation;